module.exports = __webpack_public_path__ + "static/dustin-94ec42f2f92208a638029f38f5b97e3d.png";